import { denormalize } from "normalizr";
import schemas from "utils/schemas";

export const getFacilityHeader = (state, documentId, documentTypeId = null) => {
  const facilityHeader = state.facilities.item[documentId] ? state.facilities.item[documentId] : null;

  const loading = facilityHeader && facilityHeader.loading ? true : false;
  const loaded = facilityHeader && facilityHeader.loaded ? true : false;
  const content = loaded ? denormalize(documentId, schemas.facility, state.facilities.entities) : {};

  return { loading, loaded, content: {...content, documentTypeId: content.documentTypeId ?? documentTypeId} };
};

export const getFacilityRestartRenewalData = (documentId, state) => {
  const facility = state.facilities.item[documentId]?.loaded ? state.facilities.entities.facilities[documentId] : null;

  const { offerId, offerSiteId, documentStateCode } = facility ? facility : null;
  return { offerId, offerSiteId, documentStateCode };
};
